import { useTranslation } from 'react-i18next';

import { MaterialModel, StoreModel } from '@common/models';

export interface OnlineStoresProps {
    isFetching: boolean;
    stores: StoreModel[];
    materials: MaterialModel[];
    hidden?: boolean;
}

/**
 * Displays the messaging for online store availability based on both stores and materials having data
 * @param isFetching flag for whether any dependencies are fetching
 * @param stores the list of available stores
 * @param materials the list of available materials
 * @param hidden whether to hide the entire section or not
 */
export const OnlineStores = ({ isFetching, stores, materials, hidden = false }: OnlineStoresProps) => {
    const { t } = useTranslation();

    if (hidden) {
        return <></>;
    }

    if (isFetching) {
        return <></>; // this is where we would do a loading spinner if we choose to
    }

    const isValidServiceArea = stores.length && materials.length;

    return (
        <>
            {isValidServiceArea ? (
                <div className="StoreAvailability StoreAvailability__is_available">
                    {t('ADDRESS_INFORMATION.HAS_STORE_ONLINE')}
                </div>
            ) : (
                <div className="StoreAvailability StoreAvailability__not-available">
                    {t('ADDRESS_INFORMATION.NO_STORE_ONLINE')}
                </div>
            )}
        </>
    );
};
